import { useTranslation } from 'react-i18next'

import Button, { BUTTON_HEIGHT_32 } from '../../../../Button'
import { Widget } from '../../../../Widget'
import { RentalPortalListingProfilePhotoEditorModal } from '../../RentalPortalListingProfilePhotoEditorModal'
import {
  QA_NAME_LISTING_PROFILE_WIDGET_ATTENTION,
  QA_NAME_LISTING_PROFILE_WIDGET_ATTENTION_ACTION,
} from '../RentalPortalListingProfile.constants'
import {
  useListingProfileAttentionAction,
  useListingProfileContext,
} from '../RentalPortalListingProfile.hooks'

import * as styles from './RentalPortalListingProfileWidgetAttention.module.css'

function RentalPortalListingProfileWidgetAttention() {
  const { t } = useTranslation()

  const { isInitiated } = useListingProfileContext()

  const {
    handleClickAction,
    isActionDisabled,
    isPhotoEditorOpen,
    photoEditorProps,
    primaryAction,
  } = useListingProfileAttentionAction()

  return !isInitiated || (primaryAction && !isActionDisabled) ? (
    <>
      <Widget
        contentContainerProps={{ className: styles.content }}
        headerProps={{ contentProps: { actionsProps: { EditButton: null } } }}
        isSkeleton={!isInitiated}
        qaName={QA_NAME_LISTING_PROFILE_WIDGET_ATTENTION}
        title={t('RentalPortal.OverviewNeedsAttentionTitleKey')}
      >
        {primaryAction ? (
          <Button.Outlined
            showTextTooltip
            className={styles.action}
            height={BUTTON_HEIGHT_32}
            qaName={QA_NAME_LISTING_PROFILE_WIDGET_ATTENTION_ACTION}
            text={t(primaryAction.label)}
            onClick={handleClickAction}
          />
        ) : null}
      </Widget>
      {isPhotoEditorOpen ? (
        <RentalPortalListingProfilePhotoEditorModal {...photoEditorProps} />
      ) : null}
    </>
  ) : null
}

export default RentalPortalListingProfileWidgetAttention
